<template>
  <div>
    <v-card class="ma-6">
      <v-card-title>
        <v-icon color="primary" class="mr-6">mdi-search-web</v-icon>
        Ad-hoc Scan
      </v-card-title>
      <v-card-text>
        <v-form id="formForFile">
          <v-label>
              Ad-hoc scan allows you to get marketplace pricing for a list of parts on demand.
              <br />
              <br />
          </v-label>
          <v-label>
              Upload an Excel file with the following columns, one part per row (either column 1 or 2 must be supplied):<br />
              <ol>
                  <li>CAT Code, if applicable.  If not applicable, leave blank.</li>
                  <li>Part Number, if CAT Code is blank.  If CAT Code is specified, leave this column blank.</li>
                  <li>Refined Min Quantity</li>
                  <li>Quantity Cap</li>
                  <li>Min Quantity to Scan</li>
                  <li>Additional search terms, such as "Dell", "Hard Drive", or "2TB" (optional)</li>
                  <li>Search terms to exclude, such as "ES", "QS", "Confidential", "Quality", or "Sample"</li>
              </ol>
              <br />
              <a href="/excelTemplates/SampleAdHocInput.xlsx" target="_blank">Sample input Excel file</a>
              <br />
          </v-label>
          <v-file-input label="Excel file with list of parts" v-model="file" />
          <v-btn color="primary" v-on:click="submitFile" v-if="!scanInProgress">
            <v-icon left>mdi-plus</v-icon>
              Start Scan
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- results card -->
    <v-card class="ma-6">
      <v-card-title>
        Status
      </v-card-title>
      <v-card-text>
        {{ scanStatus }}
        <v-progress-linear :color="this.statusBarColor" height="10" :value="progressPercent" class="my-6">
        </v-progress-linear>

        <v-btn color="secondary" v-on:click="cancelScan" v-if="scanInProgress && !scanComplete">
            <v-icon v-if="cancelInProgress" class="rotating" left>mdi-loading</v-icon>
            <v-icon v-else left>mdi-cancel</v-icon>
            Cancel Scan
        </v-btn>

        <v-btn color="primary" v-on:click="downloadResults" v-if="scanComplete">
            <v-icon v-if="downloadInProgress" class="rotating" left>mdi-loading</v-icon>
            <v-icon v-else left>mdi-download</v-icon>
            Download Results
        </v-btn>
      </v-card-text>
    </v-card>

    <!-- previous scans grid -->
    <adhocScanList /> 
  
  </div>
</template>

<script>
  import AdhocScanList from '../components/adhocScans/adhocScan-list.vue';

  import {AdhocScansService} from '../services/api/adhocScans';
  const apiAdhocScans = new AdhocScansService();

  import ApiClient from '../services/api/apiClient';


  export default {
    components: {
        AdhocScanList,
      },

    data: function() {
      return {
        file : null,
        
        scanInProgress: false,
        downloadInProgress: false,
        cancelInProgress: false,
        cancelTokenSource: null,
        progressPercent: 0,
        scanStatus: "Idle",
        scanComplete: false,
        isError: false,

        statusBarColor: "primary",

        latestScanID: null,
      };
    },

    created () {
      // Listen to status changes coming from SignalR events
      this.$scannerHub.$on('status-changed', this.onStatusChanged)
    },
   

    methods:
    {
      // This is called from the server through SignalR
      onStatusChanged ({ scanProgress }) {
        if (scanProgress.newStatus != null)
          this.scanStatus = scanProgress.newStatus;
        
        if (scanProgress.progressPercent != null)
          this.progressPercent = scanProgress.progressPercent;
        
        if (scanProgress.scanInProgress != null)
          this.scanInProgress = scanProgress.scanInProgress;
        
        if (scanProgress.scanComplete != null) {
          this.scanComplete = scanProgress.scanComplete;
          this.cancelInProgress = false;
        }
        
        if (scanProgress.isError != null) {
          this.isError = scanProgress.isError;
          this.cancelInProgress = false;
        }

        if (this.isError)
        {
          this.statusBarColor = "error";
        } else {
          this.statusBarColor = "primary";
        }
      },

      
      submitFile() {
        
        this.scanInProgress = true;
        this.scanComplete = true;

        // Get the form data.
        let formData = new FormData();
        
        // Append the file to the formData.
        formData.append('fileTest', this.file, this.file.name);


        this.cancelTokenSource = ApiClient.axios.CancelToken.source();

        // Send the form data to the API.
        apiAdhocScans.createAdhocScan(formData, {
          cancelToken: this.cancelTokenSource.token
        });
      },

      async downloadResults() {
        if (this.downloadInProgress) {
          return; // Prevent multiple clicks while download is in progress
        }
        try {
          this.downloadInProgress = true;
          this.$forceUpdate();

          await ApiClient.downloadFile(ApiClient.axios.defaults.baseURL + 'api/adhocScans/latest', 'AdhocScan.xlsx');
        } finally {
          this.downloadInProgress = false;
          this.$forceUpdate();
          }
      },

      async cancelScan() {
        this.cancelInProgress = true;
        try {
          await apiAdhocScans.cancelAdhocScan();
        } catch (error) {
            this.cancelInProgress = false;
            console.error("Error cancelling ad-hoc scan:", error);
            throw error; // Re-throw the error to be handled by the caller
        }
      },
    },
}
</script>

<style scoped>
.rotating {
  animation: rotation 1s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>